// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"1b991356","977":"9e3561f6"}[chunkId] + ".chunk.js";
};